<template>
  <div class="container" v-if="info.AwardListModel != null">
    <div class="top-box">
      <div v-if="info.AwardListModel.IsJuryRecommend" class="label">
        <span class="iconfont icon-zan-fill"></span>评委推荐
      </div>
      <van-image
        :src="info.AwardListModel.Thumbnail"
        fit="cover"
        @click.stop="previewHandle(0)"
      ></van-image>
    </div>
    <div class="head-box">
      <div class="hb_left">
        <span class="hbl_label">{{ info.AwardListModel.CategoryNameChi }}</span>
        <div class="hbl_title">{{ info.AwardListModel.Title }}</div>
        <div v-if="info.MemberDetail && info.MemberDetail.Headline">
          申报单位：{{ info.MemberDetail.Headline }}
        </div>
      </div>
      <button class="hb_btn" @click.stop="shareHandle">
        <span class="iconfont icon-share1"></span>分享
      </button>
    </div>
    <div class="tab-box">
      <div class="tab act">项目详情</div>
    </div>
    <div class="detail-box">
      <div v-for="(item, index) in details" :key="index">
        <!-- 1单行文本 2多行文本 3多图 4日期 6文本+图片 7多选框 8文本+视频 9文件（×）10表格  -->
        <div
          v-if="
            item.ElmType == 1 ||
            item.ElmType == 2 ||
            item.ElmType == 4 ||
            item.ElmType == 7 ||
            item.ElmType == 10
          "
        >
          <div class="db_title">{{ item.Title }}：</div>
          <div class="db_content">
            {{ item.AttrValue ? item.AttrValue : "无" }}
          </div>
        </div>
        <div v-if="item.ElmType == 3">
          <div class="db_title">{{ item.Title }}：</div>
          <div class="db_content" v-if="item.AttrValue.length > 0">
            <van-image
              :src="iItem"
              fit="contain"
              v-for="(iItem, iIndex) in item.AttrValue"
              :key="iIndex"
              @click.stop="previewHandle(1, index, iIndex)"
            ></van-image>
          </div>
          <div class="db_content" v-else>无</div>
        </div>
        <div v-if="item.ElmType == 6">
          <div class="db_title">{{ item.Title }}：</div>
          <div class="db_content" v-if="item.AttrValue.TextValue">
            {{ item.AttrValue.TextValue }}
          </div>
          <div v-if="item.AttrValue.ImageList.length > 0">
            <van-image
              :src="iItem"
              fit="contain"
              v-for="(iItem, iIndex) in item.AttrValue.ImageList"
              :key="iIndex"
              data-type="2"
              @click.stop="previewHandle(2, index, iIndex)"
            ></van-image>
          </div>
        </div>
        <div v-if="item.ElmType == 8">
          <div class="db_title">{{ item.Title }}：</div>
          <div class="db_content" v-if="item.AttrValue.TextValue">
            {{ item.AttrValue.TextValue }}
          </div>
          <div v-if="item.AttrValue.ImageList.length > 0">
            <div
              v-for="(iItem, iIndex) in item.AttrValue.ImageList"
              :key="iIndex"
            >
              <span v-if="iItem.indexOf('http') == -1">暂无，后续补充。</span>
              <video
                style="background: black"
                v-else
                controls
                width="100%"
                height="100%"
                webkit-playsinline="true"
                playsinline="true"
                preload="metadata"
                :src="iItem"
                :poster="isiOS ? iItem : ''"
              ></video>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="right-box">
      <div @click.stop="toPathHandle">
        <img src="../../../static/images/lighting/declare.png" />
      </div>
    </div>
    <!--分享-->
    <div class="shareLayer" v-show="showLayer" @click="showLayer = false">
      <img src="../../../static/images/index/layer.png" />
    </div>
    <!--遮罩层-->
    <van-overlay v-show="showLayer" @click="showLayer = false"></van-overlay>
  </div>
</template>
<script>
import sdjproject from "@/utils/sdjproject";
import { awardDetail } from "@/api/lighting";
import { formatTimeDay } from "@/utils/date";
import { getShareData } from "@/utils/share";
import { Image, ImagePreview, Overlay } from "vant";
export default {
  name: "projectDetail",
  components: {
    "van-image": Image,
    "van-overlay": Overlay,
    ImagePreview,
  },
  data() {
    return {
      id: null,
      awardType: 0,

      tab: 1,
      info: "",
      details: [],
      reasons: [],
      remark: "",
      maskflag: false,
      showLayer: false,

      isiOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    };
  },
  methods: {
    //获取详情
    getInfo() {
      var that = this;
      var data = {
        AwardTypeValue: that.awardType,
        Id: Number(that.id),
      };
      awardDetail(data).then((res) => {
        var details = res.Data.ElmList;
        details.forEach((item, index) => {
          if (item.ElmType == 3) {
            // 3纯多图
            if(item.AttrValue.endsWith(';')) item.AttrValue = item.AttrValue.slice(0, -1);
            item.AttrValue = item.AttrValue ? item.AttrValue.split(";") : "";
          }
          if (item.ElmType == 4) {
            //时间
            item.AttrValue = formatTimeDay(item.AttrValue, "-");
          }
        });
        that.info = res.Data;
        that.details = details;
        getShareData(
          window.location.href,
          res.Data.AwardListModel.Title,
          "",
          res.Data.AwardListModel.Thumbnail
        );
      });
    },

    toPathHandle() {
      window.location.href =
        "https://www.alighting.cn/webapp/award/declare.htm?t=1";
    },

    //图片预览
    previewHandle(type, idx, sidx) {
      var current = "",
        imgs = [];
      if (type == 1) {
        //图片
        var detailInfo = this.details[idx].AttrValue;
        current = detailInfo[sidx];
        imgs = detailInfo;
      } else if (type == 2) {
        //文本+图片
        var detailInfo = this.details[idx].AttrValue;
        current = detailInfo.ImageList[sidx];
        imgs = detailInfo.ImageList;
      } else {
        //详情图
        current = this.info.AwardListModel.Thumbnail;
        imgs = [current];
      }
      ImagePreview(imgs, sidx);
    },

    //分享好友
    shareHandle() {
      this.showLayer = true;
    },
  },

  mounted() {
    this.id = this.$route.query.id;
    this.awardType = this.$route.query.awardType
      ? this.$route.query.awardType
      : 0;
    if (this.Common._isMobile()) {
      this.getInfo();
    } else {
      window.location.href = `https://sdj.alighting.com/${sdjproject.getType(
        this.awardType
      )}/show/${Number(this.$route.query.id)}.html`;
    }
  },
};
</script>
<style scoped src="../../../static/css/projectDetail.css">
</style>